import { render, staticRenderFns } from "./default-header.vue?vue&type=template&id=57fdcf90&scoped=true"
import script from "./default-header.vue?vue&type=script&lang=js"
export * from "./default-header.vue?vue&type=script&lang=js"
import style0 from "./default-header.vue?vue&type=style&index=0&id=57fdcf90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57fdcf90",
  null
  
)

export default component.exports